@if (formControlItem) {
<div class="w-full text-sm tracking-tight block relative">

    @if (label) {
    <span (click)="openDropdown($event)"
        class="font-bold block mb-1 text-slate-700 text-sm tracking-wider cursor-pointer select-none">
        {{ label }}

        @if(isRequired){
        @let isInvalid = formControlItem.invalid && (formControlItem.touched || formControlItem.dirty);

        <span [class.text-gray-400]="!isInvalid" [class.text-red-500]="isInvalid">*</span>
        }

    </span>
    }

    <div class="relative w-full" [class.cursor-text]="!isDisabled" [class.cursor-default]="isDisabled"
        (click)="openDropdown($event)">

        <input #selectInput type="text" [placeholder]="placeholder" [formControl]="searchControl"
            [attr.tabindex]="tabindex" (focus)="openDropdown()"
            (keydown.enter)="$event.preventDefault(); isOpen && filteredOptions.length > 0 && selectOption(filteredOptions[0])"
            class="w-full pl-3 pr-12 py-1 bg-slate-50 border border-slate-200 rounded-2xl text-xs font-bold text-slate-700
             focus:bg-white focus:ring-4 focus:ring-blue-500/10 outline-none transition-all uppercase tracking-wider placeholder-slate-400 disabled:opacity-60 disabled:cursor-default">

        <div class="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-slate-400">
            <svg class="w-5 h-5 transition-transform duration-200 ease-in-out" [class.rotate-180]="isOpen" fill="none"
                viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
        </div>

        @if (isOpen) {
        <div #optionsList
            class="absolute left-0 right-0 z-50 w-full mt-2 bg-white border border-slate-200 rounded-2xl shadow-xl max-h-60 overflow-y-auto p-2 custom-scrollbar animate-in fade-in zoom-in-95 duration-100">

            @for (option of filteredOptions; track option[bindValue]; let first = $first; let last = $last) {
            <button type="button" (click)="selectOption(option); $event.stopPropagation()"
                (keydown.tab)="onOptionTab($event, first, last)"
                class="w-full flex items-center justify-between p-3 hover:bg-slate-50 rounded-xl text-left transition-all duration-200 group"
                [class.bg-blue-50]="isSelected(option)">
                <div class="flex items-center gap-3">
                    @if (isMultiple) {
                    <div class="w-5 h-5 flex items-center justify-center border-2 rounded-lg transition-all duration-200 ease-out shrink-0"
                        [class.border-blue-600]="isSelected(option)" [class.bg-blue-600]="isSelected(option)"
                        [class.border-slate-300]="!isSelected(option)"
                        [class.group-hover:border-slate-400]="!isSelected(option)">
                        <svg class="w-3.5 h-3.5 text-white transition-all duration-200 ease-out transform"
                            [class.scale-100]="isSelected(option)" [class.opacity-100]="isSelected(option)"
                            [class.scale-50]="!isSelected(option)" [class.opacity-0]="!isSelected(option)" fill="none"
                            viewBox="0 0 24 24" stroke="currentColor" stroke-width="3">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                        </svg>
                    </div>
                    }

                    <div class="flex flex-col">
                        <span
                            class="text-sm font-bold text-slate-700 uppercase transition-colors group-hover:text-slate-900">
                            {{ option[bindLabel] }}
                        </span>
                        @if (bindSubLabel && option[bindSubLabel]) {
                        <span class="text-[10px] font-bold text-slate-400 uppercase">
                            REF: {{ option[bindSubLabel] }}
                        </span>
                        }
                    </div>
                </div>

                <div class="flex items-center gap-2">
                    @if (bindExtra && option[bindExtra] !== undefined) {
                    <span class="text-sm font-black transition-colors duration-200"
                        [class.text-blue-600]="isSelected(option)" [class.text-slate-500]="!isSelected(option)">
                        {{ option[bindExtra] }}€
                    </span>
                    }
                    @if (!isMultiple && isSelected(option)) {
                    <span class="text-blue-600 font-bold text-xs animate-in fade-in scale-in duration-100">✓</span>
                    }
                </div>
            </button>
            } @empty {
            <div
                class="flex flex-col items-center gap-2 text-xs font-bold text-slate-400 text-center py-4 uppercase tracking-wider">
                No se encontraron resultados
                @if (createComponent) {
                <button type="button" (click)="openCreateForm($event)"
                    class="px-3 py-1.5 bg-blue-600 text-white rounded-lg text-xs font-bold uppercase tracking-wider hover:bg-blue-700 transition-colors">
                    + Crear nuevo
                </button>
                }
            </div>
            }
        </div>
        }
    </div>

    @if (showCreateForm) {
    <ng-container #createFormHost></ng-container>
    }

</div>
}